<template>
  <form @change="logChangeData">
    <div class="setting_content">
      <div class="setting_content_main">
        <h2 class="setting_content_title">
          {{ policyLabelsProperties.TAB_HEADER }}
        </h2>
        <div class="setting_unit">
          <p class="setting_unit_title">
            {{ policyLabelsProperties.POLICY_HEADER }}
          </p>
          <p class="setting_unit_explain">
            {{ policyLabelsProperties.POLICY_SUB_HEADER }}
          </p>
          <div class="setting_unit_item">
            <p class="setting_unit_label">
              {{ policyLabelsProperties.POLICY_INPUT_TITLE }}
            </p>
            <div class="setting_unit_form">
              <textarea
                class="setting_form_textarea"
                :placeholder="policyLabelsProperties.POLICY_PLACEHOLDER"
                v-model="draftPolicy.content"
                @change="validatePolicy()"
              ></textarea>
              <p v-show="lengthErrorPolicy" class="error-message">
                {{ policySettingsProperties.POLICY_MAX_LENGTH }}
                {{ errorProperties.MAX_LENGTH_CHARACTER_MESSAGE }}
              </p>
            </div>
          </div>
          <div class="setting_unit_item">
            <p class="setting_unit_label">
              {{ policyLabelsProperties.POLICY_ENABLE_CHECKBOX }}
            </p>
            <div class="setting_unit_form">
              <div class="setting_form_checkbox">
                <label class="setting_form_checkbox_label">
                  <input
                    type="checkbox"
                    v-model="policy.isEnabledPolicy"
                    value="true"
                    @change="checkEnabledPolicy()"
                  />
                  <span class="setting_form_checkbox_text">
                    {{ policyLabelsProperties.POLICY_ENABLE_OPTION }}
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="setting_unit">
          <p class="setting_unit_title">
            {{ policyLabelsProperties.LINK_HEADER }}
          </p>
          <p class="setting_unit_explain">
            {{ policyLabelsProperties.LINK_SUB_HEADER }}
          </p>
          <div class="setting_unit_item">
            <p class="setting_unit_label">
              {{ policyLabelsProperties.URL_INPUT_TITLE }}
            </p>
            <div class="setting_unit_form">
              <input
                class="setting_form_text"
                type="text"
                :placeholder="policyLabelsProperties.URL_PLACEHOLDER"
                v-model="draftPolicy.url"
                @change="validateInputUrl()"
              />
              <p v-show="lengthErrorUrl" class="error-message">
                {{ policySettingsProperties.URL_MAXLENGTH }}
                {{ errorProperties.MAX_LENGTH_CHARACTER_MESSAGE }}
              </p>
              <p v-if="formatUrlError" class="error-message">
                {{ errorProperties.WRONG_URL_FORMAT }}
              </p>
            </div>
          </div>
          <div class="setting_unit_item">
            <p class="setting_unit_label">
              {{ policyLabelsProperties.LINK_INPUT_TITLE }}
            </p>
            <div class="setting_unit_form">
              <input
                class="setting_form_text"
                type="text"
                :placeholder="policyLabelsProperties.LINK_PLACEHOLDER"
                v-model="draftPolicy.textLink"
                @change="validateInputTextLink()"
              />
              <p v-show="lengthErrorTextLink" class="error-message">
                {{ policySettingsProperties.LINK_MAX_LENGTH }}
                {{ errorProperties.MAX_LENGTH_CHARACTER_MESSAGE }}
              </p>
            </div>
          </div>
          <div class="setting_unit_item">
            <p class="setting_unit_label">
              {{ policyLabelsProperties.POLICY_ENABLE_CHECKBOX }}
            </p>
            <div class="setting_unit_form">
              <div class="setting_form_checkbox">
                <label class="setting_form_checkbox_label">
                  <input
                    type="checkbox"
                    v-model="policy.isEnabledUrl"
                    value="true"
                    @change="checkEnabledUrl()"
                  />
                  <span class="setting_form_checkbox_text">
                    {{ policyLabelsProperties.POLICY_ENABLE_OPTION }}
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import policyLabelsProperties from "../../../properties/entry_screen/policy_tab/policy-labels.json";
import policySettingsProperties from "../../../properties/entry_screen/policy_tab/policy-maxlength-settings.json";
import errorProperties from "../../../properties/entry_screen/errors.json";

export default {
  name: "PrivacyPolicyTab",
  props: ["policy", "policyError"],
  data() {
    return {
      lengthErrorPolicy: false,
      formatUrlError: false,
      lengthErrorUrl: false,
      lengthErrorTextLink: false,
      enabledPolicyError: false,
      enabledUrlError: false,
      policySettingsProperties: policySettingsProperties,
      policyLabelsProperties: policyLabelsProperties,
      errorProperties: errorProperties,
      draftPolicy: {
        content: "",
        url: "",
        textLink: "",
        isEnabledPolicy: false,
        isEnabledUrl: false,
      },
    };
  },
  watch: {
    draftPolicy: {
      handler() {
        this.validatePolicy();
        this.validateInputUrl();
        this.validateInputTextLink();
        this.checkEnabledPolicy();
        this.checkEnabledUrl();
        this.logChangeData();
      },
      deep:true
    },
  },
  computed: {
    computedPolicyError: {
      get() {
        return this.policyError;
      },
      set(val) {
        this.$emit("updatePolicyError", val);
      },
    },
  },
  mounted() {
    this.validatePolicy();
    this.validateInputUrl();
    this.validateInputTextLink();
    this.draftPolicy = this.policy;
  },
  methods: {
    logChangeData() {
      this.$eventBus.$emit("unSaved", true);
    },

    validatePolicy() {
      this.lengthErrorPolicy =
        this.draftPolicy.content.length >
        this.policySettingsProperties.POLICY_MAX_LENGTH;
      if (!this.lengthErrorPolicy) {
        this.policy.content = this.draftPolicy.content;
      }

      this.checkError();
    },
  
    checkEnabledPolicy(){
      this.enabledPolicyError = false;
      if((!this.policy.content || this.policy.content.trim().length <= 0) && this.policy.isEnabledPolicy){
        this.enabledPolicyError = true;
      }
      this.checkError();
    },

    validateInputUrl() {
      this.formatUrlError =
        this.draftPolicy.url &&
        !(
          this.draftPolicy.url.startsWith("http://") ||
          this.draftPolicy.url.startsWith("https://")
        );

      this.lengthErrorUrl =
        this.draftPolicy.url.length > this.policySettingsProperties.url;
      if (!this.lengthErrorPolicy && !this.formatUrlError) {
        this.policy.url = this.draftPolicy.url;
      }

      this.checkError();
    },

    validateInputTextLink() {
      this.lengthErrorTextLink =
        this.draftPolicy.textLink.length >
        this.policySettingsProperties.LINK_MAX_LENGTH;
      if (!this.lengthErrorTextLink) {
        this.policy.textLink = this.draftPolicy.textLink;
      }

      this.checkError();
    },

    checkEnabledUrl(){
      this.enabledUrlError = false;
      let checkTextLink = !this.policy.textLink || this.policy.textLink.trim().length <= 0;
      let checkUrl = !this.policy.url || this.policy.url.trim().length <= 0;

      if((checkTextLink || checkUrl) && this.policy.isEnabledUrl){
        this.enabledUrlError = true;
      }
      this.checkError();
    },

    checkError() {
      this.computedPolicyError =
        this.lengthErrorPolicy ||
        this.formatUrlError ||
        this.lengthErrorUrl ||
        this.lengthErrorTextLink ||
        this.enabledPolicyError ||
        this.enabledUrlError;
    },
  },
};
</script>

<style scoped>
</style>
